export default {
      id: "monthview-usage",
      viewBox: "0 0 19 22",
      url: __webpack_public_path__ + "img/icons.31feac93.svg#monthview",
      toString: function () {
        return this.url;
      }
    }